import React from 'react';
import WomensFullBody from './components/Womens/WomensFullBody';
import WomensTrousersAndJeans from './components/Womens/WomensTrousersAndJeans';
import WomensFootwearAndAccessories from './components/Womens/WomensFootwearAndAccessories';
import Lingerie from './components/Womens/Lingerie';
import MensFullBody from './components/Mens/MensFullBody';
import MensTrousersAndJeans from './components/Mens/MensTrousersAndJeans';
import MensFootwearAndAccessories from './components/Mens/MensFootwearAndAccessories';
import KidsAndToddlerFullBody from './components/KidsAndBaby/KidsAndToddlerFullBody';
import BabyAndToddler from './components/KidsAndBaby/BabyAndToddler';
import KidsAndBabyFootwearAndAccessories from './components/KidsAndBaby/KidsAndBabyFootwearAndAccessories';
var categories = ['Baby & Toddler', 'Kids & Baby Footwear & Accessories', 'Kids & Toddler Full Body', 'Lingerie', 'Mens Footwear & Accessories', 'Mens Full Body', 'Mens Trousers & Jeans', 'Womens Footwear & Accessories', 'Womens Full Body', 'Womens Trousers & Jeans'];
var pimIds = [[50002559, 50001002, 50000994, 50002561, 50000995, 50001001, 33022793, 50001003, 50000998, 50000999, 50001000, 50002776], [50000996, 50000996, 50001004, 50002629, 50002622, 50002621, 50002624, 50002623, 50002625, 50002629, 50001014, 50002653, 50002640, 50002644, 50002643, 50002645, 50002653, 50002642, 50000993, 50000997], [33009360, 50001007, 50002613, 50001008, 50002634, 50001844, 50002616, 50002627, 50001012, 50002615, 50002824, 50001010, 50002656, 50001017, 50001015, 50002636, 50001018, 50002649, 50001020, 50001023, 50001035, 50001016, 50002637, 50002638, 50002601, 50002595, 50002825, 50002610, 50002596, 50002598, 50002594, 50002599, 50002597, 50002793, 50002611, 50002603, 50002602, 50002604, 50002600, 50002606, 50002605], [50001102, 50001100, 50001101, 50001126, 50002589, 50002830, 50002829], [50002692, 50002792, 50001052, 50001066, 50001041, 50002675, 50001067, 50002673], [50001060, 50001040, 50001038, 50002671, 50001063, 50002676, 50001037, 50001091, 50001064, 50001058, 50001093, 50001036, 50002833, 33016981, 50001057], [50001039, 50001061, 50002832, 50001059, 50001062], [38916201, 50002826, 50002702, 50002695, 50002827, 50002798, 50002784, 50002785, 50002786, 50002504, 50002787, 50001042], [50002807, 50001078, 50001076, 50002808, 50001077, 50002809, 50001069, 50001083, 50001084, 50001082, 50002820, 50002795, 50002796, 50002797, 50002821, 50002814, 50001087, 50002812, 50002813, 50002815, 50002816, 50002817, 50001088, 50001086, 50001046, 50002818, 50001099, 50002819, 33016981], [50001079, 50001098, 50001081, 50001071, 50001072, 50001080, 50002810]]; // Create a map object with null as prototype

var categoryMap = Object.create(null); // Map PIM IDs with categories

pimIds.forEach(function (ids, index) {
  ids.forEach(function (id) {
    if (categoryMap[id] === undefined) {
      categoryMap[id] = categories[index];
    } else if (Array.isArray(categoryMap[id])) {
      // Prevent duplicates
      if (!categoryMap[id].includes(categories[index])) {
        categoryMap[id].push(categories[index]);
      }
    } else if (categoryMap[id] !== categories[index]) {
      categoryMap[id] = [categoryMap[id], categories[index]];
    }
  });
}); // Make categoryMap object immutable

Object.freeze(categoryMap);
/**
 * Get size guide name
 * @param {string} categoryId - PIM ID
 * @returns {(string|Object[]|undefined)}
 */

var getName = function getName(categoryId) {
  return categoryMap[categoryId];
};
/**
 * Get size guide component
 * @param {string} name - Size guide name
 * @returns {Object} React component
 */


var getComponent = function getComponent(name, dataTest) {
  var componentMap = {
    'Womens Full Body': /*#__PURE__*/React.createElement(WomensFullBody, {
      key: name,
      dataTest: dataTest
    }),
    'Womens Trousers & Jeans': /*#__PURE__*/React.createElement(WomensTrousersAndJeans, {
      key: name,
      dataTest: dataTest
    }),
    'Womens Footwear & Accessories': /*#__PURE__*/React.createElement(WomensFootwearAndAccessories, {
      key: name,
      dataTest: dataTest
    }),
    Lingerie: /*#__PURE__*/React.createElement(Lingerie, {
      key: name,
      dataTest: dataTest
    }),
    'Mens Full Body': /*#__PURE__*/React.createElement(MensFullBody, {
      key: name,
      dataTest: dataTest
    }),
    'Mens Trousers & Jeans': /*#__PURE__*/React.createElement(MensTrousersAndJeans, {
      key: name,
      dataTest: dataTest
    }),
    'Mens Footwear & Accessories': /*#__PURE__*/React.createElement(MensFootwearAndAccessories, {
      key: name,
      dataTest: dataTest
    }),
    'Kids & Toddler Full Body': /*#__PURE__*/React.createElement(KidsAndToddlerFullBody, {
      key: name,
      dataTest: dataTest
    }),
    'Baby & Toddler': /*#__PURE__*/React.createElement(BabyAndToddler, {
      key: name,
      dataTest: dataTest
    }),
    'Kids & Baby Footwear & Accessories': /*#__PURE__*/React.createElement(KidsAndBabyFootwearAndAccessories, {
      key: name,
      dataTest: dataTest
    })
  };
  return componentMap[name];
};
/**
 * Get size guide by PIM ID
 * @param {string} categoryId - PIM ID
 * @returns {(Object|Object[]|null)} React component(s)
 */


var getSizeGuide = function getSizeGuide(categoryId, dataTest) {
  var name = getName(categoryId);

  if (!name) {
    return null;
  } // It is possible for multiple size guides to be against an ID.
  // Therefore, return all size guides for that ID.


  if (Array.isArray(name)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, name.map(function (n) {
      return getComponent(n, dataTest);
    }));
  }

  return getComponent(name, dataTest);
};

export { getSizeGuide, getName };